import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const roleGuard = (requiredRole: string): CanActivateFn => {
  return () => {
    const auth = inject(AuthService);
    const router = inject(Router);
    // super-user implicitly satisfies any role requirement
    if (auth.hasRole(requiredRole) || auth.hasRole('super-user')) return true;
    router.navigate(['/unauthorized']);
    return false;
  };
};
